import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ViewMilestone = () => {
    const navigate = useNavigate();

    const milestoneDetails = {
        vendorName: "TechGadgets UAE",
        milestoneType: "Achievement",
        title: "$10,000 Revenue",
        description: "Vendor achieved revenue milestone within first 3 months.",
        value: "10000",
        createdDate: "14 Dec 2025",
        status: "Completed",
    };

    const vendorTableData = [
        {
            id: 1,
            vendor: "TechGadgets UAE",
            business: "Electronics & Gadgets",
            date: "14 Dec 2025",
        },
        {
            id: 2,
            vendor: "SmartHomes LLC",
            business: "Home Automation",
            date: "16 Dec 2025",
        },
    ];

    return (
        <>
            {/* Page Title */}
            <div className="main_title">
                <h1>Milestone Details</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/manage-vendors")}>
                        Milestones
                    </button>{" "}
                    - View
                </p>
            </div>

            <div className="cards">
                <div className="view_page view_milestone">

                    {/* Header */}
                    <div className="ov_header">
                        <div>
                            <h2>{milestoneDetails.title}</h2>
                            <p>{milestoneDetails.vendorName}</p>
                        </div>
                        <span className="status completed">
                            {milestoneDetails.status}
                        </span>
                    </div>

                    {/* Milestone Details */}
                    <div className="form">
                        <div className="gap_p">

                          
                            <div className="control_group w_33">
                                <label htmlFor="milestoneType">Milestone Type</label>
                                <p id="milestoneType">{milestoneDetails.milestoneType}</p>
                            </div>

                            <div className="control_group w_33">
                                <label htmlFor="createdDate">Created Date</label>
                                <p id="createdDate">{milestoneDetails.createdDate}</p>
                            </div>

                            <div className="control_group w_50">
                                <label htmlFor="title">Title</label>
                                <p id="title">{milestoneDetails.title}</p>
                            </div>

                            <div className="control_group w_50">
                                <label htmlFor="value">Value</label>
                                <p id="value">{milestoneDetails.value}</p>
                            </div>

                            <div className="control_group w_100">
                                <label htmlFor="description">Description</label>
                                <p id="description">{milestoneDetails.description}</p>
                            </div>

                        </div>
                    </div>

                    {/* Vendors Table */}
                    <div className="table_section mt_20">
                        <h3>Vendor Details</h3>

                        <div className="table_container">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Vendor Name</th>
                                        <th>Business Details</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {vendorTableData.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>{item.vendor}</td>
                                            <td>{item.business}</td>
                                            <td>{item.date}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="ov_footer">
                        <Button
                            variant="outlined"
                            className="btn"
                            onClick={() => navigate(-1)}
                        >
                            Back
                        </Button>

                        <Button className="btn btn_primary">
                            Edit Milestone
                        </Button>
                    </div>

                </div>
            </div>
        </>
    );
};

export default ViewMilestone;
